import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  // Table,
  Input,
  Select,
  // Checkbox,
} from "antd";
import Cookies from "js-cookie";
import Api from "../../../../services/ServiceApi";
// import { DownOutlined } from "@ant-design/icons";
import AddBusTable from "./add_bus_table/AddBusTable";
import moment from "moment";

// const adsAreaChoices = [
//   "External - FW",
//   "External - HW",
//   "External - QW",
//   "External - Special",
//   "External - In Bus",
//   "External - Hangar",
//   "External - LCD",
// ];
// const techniqueChoices = ["2D", "3D", "Lightning", "Reflective Film"];
// const lineNoChoices = ["Line No.", "Bus No.", "Plate No.", "Garage", "Model"];
// const dateChoices = ["Start Date", "Expired Date", "Available Date"];

const { Option } = Select;
// const { RangePicker } = DatePicker;

const AddBusModal = ({  handleCLose , customer , project_name , external_date , internal_date , bus_booking_id  }) => {
  const [initData, setInitData] = useState({
    busGroupData: [],
    busTypeData: [],
    adsAreaData: [],    
    busDateData: [],
    busSearchData: [],
    techniqueData: [],
  });
  const [bookedData, setBookedData] = useState([]);
  const [bookedAmount, setBookedAmount] = useState(0);
  // const [busesData, setBusesData] = useState([]);
  const [selectedRowBus, setSelectedRowBus] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [adsArea, setadsArea] = useState([]);
  const [MasterTechnique, setMasterTechnique] = useState([]);
  const [Technique, setTechnique] = useState([]);
  const [MasteradsArea, setMasteradsArea] = useState([]);
  const [original_data, setoriginal_data] = useState([]);

  const [selBusGroup, setSelBusGroup] = useState("");
  const [selCategory, setSelCategory] = useState("");
  const [selBusType, setSelBusType] = useState("");
  const [selAdsArea, setSelAdsArea] = useState([]);
  const [selTechnique, setSelTechnique] = useState([]);
  const [selDateType, setSelDateType] = useState("");


  useEffect(() => {
    
    Api.post("get_query_group_list", {
      "company_id" : "1" 
      ,"operator_id" : "3" 
      ,"project_id" : "1" 
      ,"query_id" : "6,7,9,10,11,12" 
      , "query_module" : "bus"
      ,"param_text" : "" 
      ,"where_cond" : "" 
    }).then((res) => {
      console.log(res)
      var adsArea_orginal = {};
      var Technique_orginal = {};
      const data = res.data.data
      for (let i = 0; i < data.filter_ads_area.length; i++) {
        adsArea_orginal[data.filter_ads_area[i].filter_value] = false;
      }
      for (let i = 0; i < data.filter_technique.length; i++) {
        Technique_orginal[data.filter_technique[i].filter_value] = false;
      }
      let temp = {
        busGroupData: data.bus_group_list,
        busTypeData: data.bus_type_list,
        adsAreaData: data.filter_ads_area,
        busDateData: data.filter_bus_mgt_date,
        busSearchData: data.filter_bus_mgt_search,
        techniqueData: data.filter_technique,
        original_data: data
      }

      setMasteradsArea(adsArea_orginal);
      setMasterTechnique(Technique_orginal);
      setInitData(temp)
    })
    .catch((e) => {
      console.log(e);
    });

    Api.post("get_query_group_list", {      
      "company_id" : "1" 
      ,"operator_id" : "3" 
      ,"project_id" : "1" 
      ,"query_id" : "19" 
      ,"query_module" : "bus"
      ,"param_text" : "@bus_booking_id:$"+ Cookies.get("bus_booking_id") 
      ,"where_cond" : "" 
    })
    .then((res) => {
      // setBusesData(res.data.data.list_bus_booking_add_bus)
      setFilterData(res.data.data.list_bus_booking_add_bus)
      setoriginal_data(res.data.data.list_bus_booking_add_bus);
    })
    .catch((e) => {
      console.log(e);
    });

  }, []);

  useEffect(() => {

    setSelBusGroup(selBusGroup)
    // console.log('useEffect selBusGroup', selBusGroup);

  }, { selBusGroup });

  useEffect(() => {

    setSelBusType(selBusType)
    // console.log('useEffect selBusType', selBusType);

  }, { selBusType });

  useEffect(() => {

    setFilterData(filterData)
    // console.log('useEffect filterData', filterData);

  }, { filterData });

  useEffect(() => {

    setSelTechnique(selTechnique)
    // console.log('useEffect selTechnique', selTechnique);

  }, { selTechnique });

  useEffect(() => {

    setSelAdsArea(selAdsArea)
    // console.log('useEffect selAdsArea', selAdsArea);

  }, { selAdsArea });

  useEffect(() => {

    setInitData(initData)
    // console.log('useEffect setInitData',initData);

  }, {initData});

  const searchFilter = (sel, val) => {
  console.log(val);
  console.log(original_data);
    let tempFilteredData = filterData;

    if(val){
      if (sel === "bus_group") {
        tempFilteredData = [];
        // tempFilteredData = original_data.filter((i) => i.bus_group_name === val)
        // setBusesData(tempFilteredData)

        // setFilterData(tempFilteredData)
        setSelBusGroup(val)
      }
      if (sel === "bus_type") {
        // tempFilteredData = original_data.filter((i) => i.bus_type_name === val)
        // setBusesData(tempFilteredData)

        // setFilterData(tempFilteredData)
        setSelBusType(val)
  
        // console.log(tempFilteredData);
      }
      if (sel === "ads_area") {
        var defaultFlase = 0;
        var setdata = [];
        var countAds = 0;
        for (const [key, value] of Object.entries(MasteradsArea)) {
          if (value) {
            const filterAds = original_data.filter((i) => i[key.toLowerCase()] === 1);
            if (filterAds != 0) {
              setdata.push(filterAds);
            }
            countAds++;
          }
          else {
            defaultFlase++;
          }
          if (defaultFlase === Object.keys(MasteradsArea).length) {
            setdata = original_data;
            countAds = 0;
          }
        }
        setadsArea(countAds === 0 ? [] : ["Ads Area " + countAds]);
        // setFilterData(setdata);
      }
      if (sel === "technique") {
        var defaultFlase = 0;
        var setdata = [];
        var countTec = 0;
        for (const [key, value] of Object.entries(MasterTechnique)) {
          if (value) {
            const filterTec = original_data.filter((i) => i[key.toLowerCase()] === 1);
            if (filterTec != 0) {
              setdata.push(filterTec);
            }
            countTec++;
          }
          else {
            defaultFlase++;
          }
          if (defaultFlase === Object.keys(MasterTechnique).length) {
            setdata = original_data;
            countTec = 0;
          }
        }
        setTechnique(countTec === 0 ? [] : ["Technique " + countTec]);
        // setBusesData(setdata);
        // setFilterData(setdata)
      }
    } else {
      if (sel === "bus_group") {
        setSelBusGroup("")

      }
      if (sel === "bus_type") {
        setSelBusType("")
      }
      if (sel === "technique") {
        setTechnique([])
      }
      if(sel === "ads_area"){
        setadsArea([])
      }
        // setFilterData(original_data);
    }

  }

  const searchDetail = async (value) => {
    console.log(value);
    await setFilterData([]);
    // console.log(selCategory);
    // console.log(selBusGroup);
    // console.log(selAdsArea);
    // console.log(selTechnique);
    // console.log(selBusType);

    let tempFilteredData = [];
    if (value === "") {
      tempFilteredData = original_data;
    }
    else {
      if (selCategory === "bus_line.bus_line_name") {
        tempFilteredData = original_data.filter((i) => i.bus_line_name.includes(value))
      }
      if (selCategory === "bus.bus_no") {
        tempFilteredData = original_data.filter((i) => i.bus_no.includes(value))
      }
      if (selCategory === "bus.license_plate") {
        tempFilteredData = original_data.filter((i) => i.license_plate.includes(value))
        console.log(tempFilteredData);

      }
      if (selCategory === "garage.garage_name") {
        tempFilteredData = original_data.filter((i) => i.garage_name.includes(value))
      }
      if (selCategory === "model.model_name") {
        tempFilteredData = original_data.filter((i) => i.model_name.includes(value))
      }

      
      if (selBusGroup) {
        tempFilteredData = tempFilteredData.filter((i) => i.bus_group_name === selBusGroup);
      }

      if (selBusType) {
        tempFilteredData = tempFilteredData.filter((i) => i.bus_type_name === selBusType)
      }

      if (selAdsArea.length > 0) {
        // console.log('area f');
        if (selAdsArea[1] === "FW") {
          tempFilteredData = tempFilteredData.filter((i) => i.fw === true)
        }
        if (selAdsArea[1] === "HW") {
          tempFilteredData = tempFilteredData.filter((i) => i.hw === true)
        }
        if (selAdsArea[1] === "QW") {
          tempFilteredData = tempFilteredData.filter((i) => i.qw === true)
        }
        if (selAdsArea[1] === "Special") {
          tempFilteredData = tempFilteredData.filter((i) => i.special === true)
        }
        if (selAdsArea[1] === "IB") {
          tempFilteredData = tempFilteredData.filter((i) => i.ib === true)
        }
        if (selAdsArea[1] === "HG") {
          tempFilteredData = tempFilteredData.filter((i) => i.hg === true)
        }
        if (selAdsArea[1] === "LCD") {
          tempFilteredData = tempFilteredData.filter((i) => i.lcd === true)
        }
      }

      if (selTechnique.length > 0) {
        if (selTechnique[1] === "2D") {
          tempFilteredData = tempFilteredData.filter((i) => i["2D"] === true)
        }
        if (selTechnique[1] === "3D") {
          tempFilteredData = tempFilteredData.filter((i) => i["3D"] === true)
        }
        if (selTechnique[1] === "LED") {
          tempFilteredData = tempFilteredData.filter((i) => i.led === true)
        }
        if (selTechnique[1] === "Reflective_film") {
          tempFilteredData = tempFilteredData.filter((i) => i.reflective_film === true)
        }
      }
    }
     setFilterData(tempFilteredData)
  };

  const FilterDate = (value) => {
    if(value != null ){
      if (selDateType === "internal_ad_start,external_ad_start") {
        const filteredItemsNotnull = original_data.filter((data) => data.internal_ad_start !== null || data.external_ad_start !== null);
        const filteredItems = filteredItemsNotnull.filter((item) => 
       (moment(converDate(item.internal_ad_start)).isBetween(converDate(value[0]), 
       moment(converDate(value[1])).add(1, 'days')) === true ) || 
       (moment(converDate(item.external_ad_start)).isBetween(converDate(value[0]), 
       moment(converDate(value[1])).add(1, 'days')) === true ) 
        )
        setFilterData(filteredItems);
      }
      if (selDateType === "internal_ad_end,external_ad_end") {
        const filteredItemsNotnull = original_data.filter((data) => data.internal_ad_end !== null ||  data.external_ad_end !== null );
        const filteredItems = filteredItemsNotnull.filter((item) => 
       (moment(converDate(item.internal_ad_end)).isBetween(converDate(value[0]), 
       moment(converDate(value[1])).add(1, 'days')) === true ) || 
       (moment(converDate(item.external_ad_end)).isBetween(converDate(value[0]), 
       moment(converDate(value[1])).add(1, 'days')) === true ) 
        )
        setFilterData(filteredItems);
      }
    }
    else
    {
      setFilterData(original_data);
    }  
  }

  const converDate = (item) => {
    if (item === null) {
      // return moment(new Date()).format("YYYY-MM-DD")
      return null
    }
    else {
      if (moment(item, "DD/MM/YYYY").format("YYYY-MM-DD") === "Invalid date") {
        return moment(item).format("YYYY-MM-DD")
      }
      else {
        return moment(item, "DD/MM/YYYY").format("YYYY-MM-DD")
      }
    }


  }

  const submit_add = () => {
    let arr_bus = []
    for(let i=0;i<selectedRowBus.length;i++){
      console.log('bus_id',selectedRowBus[i].bus_id);
      arr_bus.push(selectedRowBus[i].bus_id)
    }

    //Api.post("addBusBooking", {
    Api.post("booking", {
      bus_array: arr_bus,
      customer: customer,
      external_date: external_date,
      internal_date: internal_date,
      project_name: project_name,
      bus_booking_id: bus_booking_id
    }).then((res) => {
      console.log('addBusBooking',res.data.result.description)
      alert('add bus success')
      // console.warn('respond from booking modal', res)
           window.location.reload(false);
      //     handleVisible(false)

    });
  }

  return (
    <>
      <Modal
        title="ADD BUS"
        visible={true}
        width={750}
        onCancel={() => handleCLose()}
        footer={[
          <div className="text-center">
            {[
              <Button key="Cancel" onClick={() => handleCLose()}>
                Cancel
              </Button>,
              <Button
                key="Add"
                className="btn-warning"
                style={{ background: "#E8CD00" }}
                onClick={() => submit_add()}
              >
                Submit
              </Button>,
            ]}
          </div>,
        ]}
      >
        {/* for many input */}
        <div style={{ padding: "0 40px" }}>
          <div className="d-flex align-items-start mb-2">
            <Input.Group compact>
              {/* Bus Group dropdown  without choice*/}
              <Select
                  placeholder="Bus Group"
                  // value="Bus Group"
                  allowClear
                  style={{ width: "140px" }}
                  onChange={(val) => {
                    searchFilter('bus_group', val)
                  }}
            
                >
                  {initData.busGroupData.map((data, index) => (
                    <Option
                      key={`busGroup_${index}`}
                      value={data.bus_group_name}
                    >
                      {data.bus_group_name}
                    </Option>
                  ))}
                </Select>
              {/* Bus Type dropdown without choice */}
              <Select
                placeholder="Bus Type"
                // value="Bus Type"
                style={{ width: "140px" }}
                allowClear
                onChange={(val) => {
                  searchFilter('bus_type', val)
                }}
              >
                  {initData.busTypeData.map((data, index) => (
                    <Option
                      key={`busType_${index}`}
                      value={data.bus_type_name}
                    >
                      {data.bus_type_name}
                    </Option>
                  ))}

              </Select>
              {/* Ads area dropdown */}
              {/* <Select
                  mode="multiple"
                  showArrow={true}
                  showSearch={false}
                  placeholder="Ads. Area"
                  value="Ads. area"
                  style={{ width: "140px" }}
                  allowClear
                >
                  {initData.adsAreaData.map((data, index) => (
                    <Option
                    key={index}
                    >
                               <Checkbox key={index}
                        onChange={(val) => {
                          MasteradsArea[data.filter_value] = val.target.checked;
                          searchFilter('ads_area', data.filter_value)
                        }}
                      >{data.filter_name}</Checkbox>
                    </Option>
                  ))}
                </Select> */}

              {/* Technique dropdown */}
                {/* <Select
                  allowClear
                  mode="multiple"
                  placeholder="Technique"
                  value={<span style={{"background":"none"}}>Technique</span>}
                  showArrow={true}
                  showSearch={false}
                  style={{ width: "140px", "margin-right": "1rem" }}

                >
                  {initData.techniqueData.map((data, index) => (
                    <Option
                    key={index}
                    >
                <Checkbox key={index}
                        onChange={(val) => {
                          MasterTechnique[data.filter_value] = val.target.checked;
                          searchFilter('technique', data.filter_value)
                        }}
                      >{data.filter_name}</Checkbox>
                    </Option>
                  ))}

                </Select> */}
            </Input.Group>
          </div>
          <div className="d-flex align-items-start mb-2">
            <Input.Group compact>
              {/* <Select
                allowClear
                placeholder="Date"
                style={{ width: "140px", "margin-right": "1rem" }}
                onChange={() => {}}
                // mode="multiple"
                // allowClear
              >
                {initData.busDateData.map((data, index) => (
                    <Option
                      key={`busDate_${index}`}
                      value={data.filter_value}
                    >
                      {data.filter_name}
                    </Option>
                  ))}
              </Select>
              <RangePicker
                onChange={(e) => {
                  FilterDate(e)
                }}
                allowClear
                style={{
                  marginLeft: "10px",
                  color: "#000F9F",
                  marginRight: "20px",
                }}
              /> */}
            </Input.Group>
          </div>
          <div className="d-flex align-items-start mb-2">
            <Input.Group>
              {/* Line No dropdown  */}{/* Line No dropdown  */}
                <Select
                  allowClear
                  placeholder="Line No."
                  style={{ width: "140px", "margin-right": "1rem" }}
                  onChange={(val) => setSelCategory(val)}
                  // mode="multiple"
                  // allowClear
                >
                  {initData.busSearchData.map((data, index) => (
                    <Option
                      key={`busSearch_${index}`}
                      value={data.filter_value}
                    >
                      {data.filter_name}
                    </Option>
                  ))}
                </Select>
              {/* Search */}
              <Input.Search
                allowClear
                placeholder="Search"
                onSearch={(value) => searchDetail(value)}
                style={{ width: "250px", "margin-right": "1rem" }}
                enterButton
              />
              {/* <button onClick={() => {}} className="btn btn-blue">
                Search
              </button> */}
            </Input.Group>
          </div>
        </div>
        <hr />
        {/* for booking table */}
        {/* <button className="btn btn-warning" 
        // onClick={() => bookingBus()}
        >
        Booking ({bookedAmount})
      </button> */}

        <AddBusTable
          setBookedData={setBookedData}
          setBookedAmount={setBookedAmount}
          busesData={filterData}
          setSelectedRowBus={setSelectedRowBus}
        />
      </Modal>
    </>
  );
};

export default AddBusModal;
